import { NavLink } from 'react-router-dom';
import { Building2, FlaskConical } from 'lucide-react';

export function SendChannelNav() {
    return (
        <div className="send-channel-nav" aria-label="发送方式">
            <NavLink to="/bulk-send" className={({ isActive }) => isActive ? 'active' : ''}>
                <Building2 size={15} />
                <span><strong>对外发送</strong><small>联系人名单 · Outlook 或 SpaceMail</small></span>
            </NavLink>
            <NavLink to="/internal-send" className={({ isActive }) => isActive ? 'active internal' : ''}>
                <FlaskConical size={15} />
                <span><strong>内部测试</strong><small>Outlook 账号池 → 自有 SpaceMail 邮箱</small></span>
            </NavLink>
        </div>
    );
}
